<template>
  <div class="loginPage">
    <div class="sticky">
      <NavBar :bgColor="'#1A3232'"/>
    </div>
    
    <Login :loginType="1"/>


  </div>
</template>

<script>

import NavBar from '@/components/NavBar/index.vue'
import Login from '@/components/Login/index.vue'
export default {
  name: 'Register',
  data(){
    return {
      loginType:0,

      
    }
  },
  components: {
    NavBar,
    Login,
  },
  methods:{
 
  }
}
</script>

<style lang="scss" scoped>

  .loginPage{
    width: 100%;
    height: 100%;
    .sticky{
      position: -webkit-sticky; /* Safari 兼容 */
      position: sticky;
      top: 0;
    }
   
    

      
  }
  
</style>
